import { GENERAL_SERVER_ERROR } from "../constants/config";
import { appNotification } from "../components/common/notification";

export const getPaginatedUserMessages = async (filterParams: FilterParameters): Promise<PaginatedResponse<ChatMessage> | null> => {
    let queryString = `?page_size=${filterParams.pageSize}&from_date=${filterParams.fromDate}&to_date=${filterParams.toDate}`
    if(filterParams.userId)
        queryString = `${queryString}&user_id=${filterParams.userId}`
    if(filterParams.nextToken)
        queryString = `${queryString}&next_token=${filterParams.nextToken}`
    if(filterParams.category_3)
        queryString = `${queryString}&category_3=${filterParams.category_3}`
    if(filterParams.feedbackRating !== undefined)
        queryString = `${queryString}&feedback_rating=${filterParams.feedbackRating}`
    const response = await fetch(`${import.meta.env.VITE_API_ADMIN_URL}/messages${queryString}` , {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include"
        }).then((res) => {
            // console.log("getPaginatedUserMessages ", res)
            if(res.status === 401){
                window.location.href = '/login';
            }
            return res.json();
        }).then((data) => {
            // console.log("getPaginatedUserMessages data ", data)
            if(data.detail){
                appNotification.error({ message: "Retrieving records", description: data.detail });
                return null
            }
            else{
                return data as PaginatedResponse<ChatMessage>
            }
        }).catch((err) => {
            console.error("There was an issue fetching your data.", err);
            appNotification.error({message: "Retrieving records", description: GENERAL_SERVER_ERROR});
            return null
        })
    
        return response
}

export const exportMessagesToCSV = async (filterParams: FilterParameters)=> {
    let queryString = `?from_date=${filterParams.fromDate}&to_date=${filterParams.toDate}`
    if(filterParams.userId)
        queryString = `${queryString}&user_id=${filterParams.userId}`
    if(filterParams.category_3)
        queryString = `${queryString}&category_3=${filterParams.category_3}`
    if(filterParams.feedbackRating !== undefined)
        queryString = `${queryString}&feedback_rating=${filterParams.feedbackRating}`
    return await fetch(`${import.meta.env.VITE_API_ADMIN_URL}/messages/export${queryString}` , {
        credentials: "include",
    })
    .then((res) => {
        if(res.status === 401){
            window.location.href = '/login';                
        }
        return res.blob();
    })
    .then((blob) => {
        if (!blob) return; 
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `queries.csv`;
        a.click();
        window.URL.revokeObjectURL(url);}
    ).catch((error) => {
        console.log(error)
        appNotification.error({message: "Retrieving records", description: GENERAL_SERVER_ERROR});
    });   
}

export const getClassificationBreakdown = async (filterParams: FilterParameters): Promise<Record<string, number> | null> => {
    let queryString = `?from_date=${filterParams.fromDate}&to_date=${filterParams.toDate}`;
    
    if (filterParams.userId)
        queryString += `&user_id=${filterParams.userId}`;
    if (filterParams.category_3)
        queryString += `&category_3=${filterParams.category_3}`;
    if (filterParams.feedbackRating !== undefined)
        queryString += `&feedback_rating=${filterParams.feedbackRating}`;
    
    const response = await fetch(`${import.meta.env.VITE_API_ADMIN_URL}/messages/classification-breakdown${queryString}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    }).then((res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json();
    }).then((data) => {
        if (data.detail) {
            appNotification.error({ message: "Fetching chart data", description: data.detail });
            return null;
        } else {
            return data.classificationBreakdown as Record<string, number>;
        }
    }).catch((err) => {
        appNotification.error({ message: "Fetching chart data", description: GENERAL_SERVER_ERROR });
        return null;
    });

    return response;
}

